<template>
<!--  <button type="button" class="text-white bg-yellow-400 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2">Avaliador</button>-->
<!--  <button type="button" class="text-white bg-purple-700 font-medium rounded-lg text-sm px-5 py-2.5 mb-2">Visitante</button>-->

  <div class="relative p-4 w-full max-w-md h-full">
      <div class="p-6">
        <p class="text-sm font-normal text-gray-500">Por favor, selecione uma opção para acesso às votações.</p>
        <ul class="my-4 space-y-3">
          <li>
            <a :href="route('mobile.avaliador.avaliar-mesa')" class="flex items-center p-3 text-base font-bold text-white bg-blue-500 rounded-lg group">
              <span class="flex-1 whitespace-nowrap">Avaliador</span>
            </a>
          </li>
          <li>
            <a :href="route('mobile.visitante.avaliar-mesa')" class="flex items-center p-3 text-base font-bold text-white bg-gray-500 rounded-lg group">
              <span class="flex-1 whitespace-nowrap">Voto Popular</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
  name: "LandingPage.vue"
}
</script>

<style scoped>

</style>
